/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */
module.exports = {
    tag: 'light',
    quality: 0.1,
    toughness: -2,
    speed: 0.4
}